import React from 'react';
import cx from 'clsx';
import { ComponentType } from '../../../util/ComponentType';
import { Anchor, ContenfulNested } from '../../../util/types';
import dynamic from 'next/dynamic';
import classes from './NavigationButton.module.scss';

const AnchorElement = dynamic(() => import('../../../common/Anchor/Anchor'));
const Text = dynamic(() => import('../../../common/Text/Text'));

export interface NavigationButtonProps extends React.HTMLProps<HTMLButtonElement> {
  type?: 'button' | 'submit' | 'reset';
  elementRef?: React.Ref<any>;
  withLinks?: boolean;
  button: ContenfulNested<Anchor> | string;
  children?: ContenfulNested<Anchor>[];
  active: boolean;
}

export default function NavigationButton<T extends React.ElementType = 'button'>({
  className,
  type = 'button',
  elementRef,
  button,
  withLinks,
  children,
  active,
  ...others
}: NavigationButtonProps & ComponentType<T>) {

  if (withLinks) {
    return (
      <button
        className={cx(className, classes.navigationButton, { [classes.active]: active })}
        type={type}
        ref={elementRef}
        {...others}
      >
        <Text bold>{typeof button === 'string' ? button : button.fields.children}</Text>
      </button>
    );
  }

  if (typeof button !== 'string') {
    return (
      //@ts-ignore
      <AnchorElement
        className={cx(className, classes.navigationButton, { [classes.active]: active })}
        ref={elementRef}
        bold
        {...others}
        {...button.fields}
      />
    );
  }

  return null;
}

NavigationButton.displayName = '@ioa/lablocator/NavigationButton';
